import type { ResourceType } from 'fleet-greenkeeper-bff-contracts';

export type RasterColor = [number, number, number];

export type DilationRadius = 0 | 1 | 2 | 3 | 4 | 5;

export type RenderMode = 'colorRamp' | 'heatmap' | 'topography';

/**
 * Fixed render mode per layer type.
 * This is not user-configurable and not persisted to localStorage.
 */
export const RENDER_MODES: Record<ResourceType, RenderMode> = {
  ndvi: 'colorRamp',
  ndmi: 'colorRamp',
  ndre: 'colorRamp',
  cutIntensity: 'colorRamp',
  slipHeatmap: 'heatmap',
  slopePolygons: 'topography',
};

export type RasterParams = {
  dilationRadius: DilationRadius; // dilation radius (pixels, 0..3 in shader)
  opacity: number; // 0..1
  cutoffMin: number;
  mid: number;
  cutoffMax: number;
  autoCutoff: boolean; // when true, cutoffs are auto-computed from image metadata
  colorVeryLow: RasterColor;
  colorLow: RasterColor;
  colorMedium: RasterColor;
  colorHigh: RasterColor;
  visible: boolean;
};

export type SlopePolygonsParams = RasterParams & {
  showContours: boolean;
};

export type RenderableRasterParams = RasterParams & {
  showContours?: boolean;
};

export type LayerSettingsByType = {
  ndvi: RasterParams;
  ndmi: RasterParams;
  ndre: RasterParams;
  cutIntensity: RasterParams;
  slipHeatmap: RasterParams;
  slopePolygons: SlopePolygonsParams;
};

export const CUTOFF_FIELDS: ReadonlySet<keyof RasterParams> = new Set([
  'cutoffMin',
  'mid',
  'cutoffMax',
]);
